import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import regeneratorRuntime from "/home/jenkins/agent/workspace/web-sunrise-noprod/web-sunrise-stories-deploy-dev/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@vfit/shared/atoms";
import { purify } from "@vfit/shared/themes";
import { FormProvider, useForm } from "react-hook-form";
import { getVariantByActionStyle, isJSON } from "@vfit/shared/data-access";
import { useState } from "react";
import { CustomCheckbox, CustomInput, CustomRadio, CustomSelect } from "./components";
import * as S from "./cmsForm.style";
import { createSubmitMethod } from "./cmsForm.utils";
// How to use? Docs
// const testForm = organizeForm({});
// const signUpForm = getInputs(testForm);
// const initialValuesSignUp = {
//   ...signUpForm.initialValues,
//   piva: 'test piva',
// };
// <CmsForm
//   {...signUpForm}
//   initialValues={initialValuesSignUp}
//   titleForm="Form dinamiche Vuoi maggiori informazioni?"
//   descriptionForm="Lascia i tuoi dati e ti contatteremo al più presto."
//   onSubmit={onSubmitSignUp}
//   labelButtonSubmit="Ti chiamiamo gratis"
// />
var CmsForm = function(_param) {
    var props = _extends({}, _param);
    var ref;
    var initialValues = props.initialValues, inputs = props.inputs, onFormSubmitted = props.onFormSubmitted, onCustomSubmit = props.onCustomSubmit, onErrorForm = props.onErrorForm, onSuccessForm = props.onSuccessForm, onTrackSubmit = props.onTrackSubmit, submitConfig = props.submitConfig, validationSchema = props.validationSchema, config = props.config;
    var titleForm = config.title, descriptionForm = config.description, footer = config.footer, textAlignForm = config.textAlign;
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = _sliced_to_array(purify([
        titleForm,
        descriptionForm,
        footer
    ]), 3), pTitleForm = ref2[0], pDescriptionForm = ref2[1], pFooter = ref2[2];
    var formMethods = useForm(_object_spread_props(_object_spread({}, !(submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.alwaysEnabledSubmitButton) && {
        mode: "onBlur"
    }), {
        resolver: yupResolver(validationSchema),
        defaultValues: _object_spread({}, initialValues)
    }));
    var formSubmit = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(data) {
            var successConfig, errorsConfig, ref, url, headers, body, method, submitResponse, response, dataRes;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        onTrackSubmit === null || onTrackSubmit === void 0 ? void 0 : onTrackSubmit();
                        if (!onCustomSubmit) {
                            _ctx.next = 4;
                            break;
                        }
                        onCustomSubmit(data);
                        return _ctx.abrupt("return");
                    case 4:
                        successConfig = submitConfig.success, errorsConfig = submitConfig.errors;
                        ref = createSubmitMethod(data, inputs, submitConfig), url = ref.url, headers = ref.headers, body = ref.body, method = ref.method;
                        submitResponse = function(type, errorCmsApi) {
                            if (type === "success") onSuccessForm === null || onSuccessForm === void 0 ? void 0 : onSuccessForm(successConfig);
                            else onErrorForm === null || onErrorForm === void 0 ? void 0 : onErrorForm(errorsConfig, errorCmsApi);
                        };
                        _ctx.prev = 7;
                        setIsLoading(true);
                        _ctx.next = 11;
                        return fetch(url, {
                            method: method,
                            headers: headers,
                            body: body
                        });
                    case 11:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 16;
                            break;
                        }
                        {
                            setIsLoading(false);
                            onFormSubmitted === null || onFormSubmitted === void 0 ? void 0 : onFormSubmitted(data);
                            submitResponse("success");
                        }
                        _ctx.next = 21;
                        break;
                    case 16:
                        _ctx.next = 18;
                        return response === null || response === void 0 ? void 0 : response.text();
                    case 18:
                        dataRes = _ctx.sent;
                        setIsLoading(false);
                        submitResponse("error", {
                            status: (response === null || response === void 0 ? void 0 : response.status) || 500,
                            data: isJSON(dataRes) ? JSON.parse(dataRes) : data
                        });
                    case 21:
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](7);
                        setIsLoading(false);
                        submitResponse("error", {
                            status: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.status) || 500
                        });
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    23
                ]
            ]);
        }));
        return function formSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var createInputs = function() {
        return(// eslint-disable-next-line @typescript-eslint/no-unused-vars
        inputs.map(function(_param) {
            var validations = _param.validations, typeValue = _param.typeValue, value = _param.value, inputProps = _object_without_properties(_param, [
                "validations",
                "typeValue",
                "value"
            ]);
            switch(inputProps.type){
                case "select":
                    return /*#__PURE__*/ _createElement(CustomSelect, _object_spread_props(_object_spread({}, inputProps), {
                        key: inputProps.name,
                        isPendingRequest: isLoading
                    }));
                case "checkbox":
                    return /*#__PURE__*/ _createElement(CustomCheckbox, _object_spread_props(_object_spread({}, inputProps), {
                        key: inputProps.name,
                        isPendingRequest: isLoading
                    }));
                case "radio":
                    return /*#__PURE__*/ _createElement(CustomRadio, _object_spread_props(_object_spread({}, inputProps), {
                        key: inputProps.name,
                        isPendingRequest: isLoading
                    }));
                default:
                    return /*#__PURE__*/ _createElement(CustomInput, _object_spread_props(_object_spread({}, inputProps), {
                        key: inputProps.name,
                        isPendingRequest: isLoading
                    }));
            }
        }));
    };
    var isDisabledSubmit = (submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.alwaysEnabledSubmitButton) ? isLoading : isLoading || !(formMethods === null || formMethods === void 0 ? void 0 : (ref = formMethods.formState) === null || ref === void 0 ? void 0 : ref.isValid);
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, formMethods), {
        children: /*#__PURE__*/ _jsxs("form", {
            onSubmit: formMethods.handleSubmit(formSubmit),
            children: [
                /*#__PURE__*/ _jsxs(S.StyledFormTextContainer, {
                    textAlign: textAlignForm,
                    children: [
                        pTitleForm && /*#__PURE__*/ _jsx("h2", {
                            dangerouslySetInnerHTML: {
                                __html: pTitleForm
                            }
                        }),
                        pDescriptionForm && /*#__PURE__*/ _jsx("h4", {
                            dangerouslySetInnerHTML: {
                                __html: pDescriptionForm
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(S.StyledSection, {
                    children: createInputs()
                }),
                (submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.label) && /*#__PURE__*/ _jsx(S.StyledContainerButton, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        disabled: isDisabledSubmit,
                        variant: getVariantByActionStyle(submitConfig.variant),
                        children: submitConfig.label
                    })
                }),
                pFooter && /*#__PURE__*/ _jsx(S.StyledFormTextContainer, {
                    textAlign: textAlignForm,
                    style: {
                        marginBottom: 40
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        dangerouslySetInnerHTML: {
                            __html: pFooter
                        }
                    })
                })
            ]
        })
    }));
};
export default CmsForm;
